export default function IFS() {
  return (
    <div className="p-4">
      <h1>IFS</h1>
    </div>
  );
}
